<template>
<div>
</div>
</template>

<script>
import { useClient, useMutation } from 'villus';
import { gql } from 'graphql-tag';
import { computed, reactive } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'updateActiveCoursesMutation',

  setup() {
    const store = useStore();

    useClient({
      url: process.env.VUE_APP_STRAPI,
    });

    const updateActiveCoursesMutation = gql`
      mutation($id: ID!, $activeCourseIds: String!) {
        updateUserData(id: $id, data: { activeCourseIds: $activeCourseIds }) {
          data {
            id
          }
        }
      }
      `;

    const context = reactive({
      headers: computed(() => store.state.auth.headers),
    });

    const { execute: updateActiveCourses } = useMutation(updateActiveCoursesMutation, {
      context,
    });

    store.commit('setStrapiExecutionHandler', { item: 'updateActiveCourses', result: updateActiveCourses });
  },
};
</script>
